import { render, staticRenderFns } from "./CustomerInquiryReg.vue?vue&type=template&id=30d13eb6&scoped=true"
import script from "./CustomerInquiryReg.vue?vue&type=script&lang=js"
export * from "./CustomerInquiryReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d13eb6",
  null
  
)

export default component.exports